/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tag } from './Tag';
import {
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
    TagToJSONTyped,
} from './Tag';

/**
 * 
 * @export
 * @interface CreateTagResponse
 */
export interface CreateTagResponse {
    /**
     * 
     * @type {Tag}
     * @memberof CreateTagResponse
     */
    data: Tag;
}

/**
 * Check if a given object implements the CreateTagResponse interface.
 */
export function instanceOfCreateTagResponse(value: object): value is CreateTagResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateTagResponseFromJSON(json: any): CreateTagResponse {
    return CreateTagResponseFromJSONTyped(json, false);
}

export function CreateTagResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTagResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TagFromJSON(json['data']),
    };
}

  export function CreateTagResponseToJSON(json: any): CreateTagResponse {
      return CreateTagResponseToJSONTyped(json, false);
  }

  export function CreateTagResponseToJSONTyped(value?: CreateTagResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TagToJSON(value['data']),
    };
}

